
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

interface PublishedExpert {
  id: string;
  application_id: string;
  status: 'active' | 'inactive' | 'draft' | 'pending_approval' | 'suspended';
  full_name: string;
  professional_title: string;
  bio: string;
  years_experience: number;
  specializations: string[];
  hourly_rate: number;
  admin_notes: string | null;
  approved_by: string | null;
  approved_at: string | null;
  created_at: string;
  updated_at: string;
}

export function usePublishedExperts() {
  const [publishedExperts, setPublishedExperts] = useState<PublishedExpert[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchPublishedExperts = async () => {
    try {
      console.log("🔄 Fetching published experts...");
      const { data, error } = await supabase
        .from("consultation_experts")
        .select(`
          id, 
          application_id, 
          status, 
          full_name, 
          professional_title, 
          bio,
          years_experience,
          specializations,
          hourly_rate,
          admin_notes,
          approved_by,
          approved_at,
          created_at, 
          updated_at
        `)
        .order("created_at", { ascending: false });

      if (error) {
        console.error("❌ Error fetching published experts:", error);
        throw error;
      }

      console.log("✅ Fetched published experts:", data?.length || 0);
      console.log("📊 Published experts data:", data);
      
      // Log each expert's details
      data?.forEach(expert => {
        console.log(`👤 Expert: ${expert.full_name}, Status: ${expert.status}, App ID: ${expert.application_id}`);
      });
      
      setPublishedExperts(data || []);
    } catch (error) {
      console.error("💥 Error in fetchPublishedExperts:", error);
      toast.error("Failed to load published experts");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPublishedExperts();
  }, []);

  return {
    publishedExperts,
    loading,
    fetchPublishedExperts
  };
}
